import type { PlatformBridge } from "@acto/taskpane/core/platform/messaging/bridge";
import type { PlatformPlugin } from "@acto/taskpane/core/platform/PlatformPlugin";
import type { PlatformEnv } from "@acto/taskpane/core/platform/runtime/env";

const C4cPlugin: PlatformPlugin<void> = {
  name: "c4c",
  mayWithholdRefreshCookie: true,

  canBoot(env: PlatformEnv) {
    return env.platform?.toLowerCase() === "c4c";
  },

  async boot(_env: PlatformEnv) {
    void _env;
  },

  registerMessaging(bridge: PlatformBridge) {
    if (typeof window === "undefined") return;

    const accountId = new URL(window.location.href).searchParams.get("accountID");
    if (!accountId) return;

    bridge.dispatch({
      type: "crm.entity",
      payload: { crmId: accountId },
    });
  },
};

export default C4cPlugin;
